import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';

// Primary — full-width gradient-filled button (from AuthLogin)
const PRIMARY_GRADIENT = 'linear-gradient(135deg,#7852f8,#84aef6)';

const Primary = styled(Button)(() => ({
  background: PRIMARY_GRADIENT,
  color: '#FFFFFF',
  borderRadius: '10px',
  textTransform: 'none',
  // height: '54px',
  fontSize: { xs: '0.85rem', sm: '1rem' },
  fontWeight: 600,
  boxShadow: 'none',
  padding: '12px 18px 12px 16px',
  '&:hover': {
    background: PRIMARY_GRADIENT,
    boxShadow: 'none',
  },
  '&.Mui-disabled': {
    color: '#FFFFFF',
    opacity: 0.7,
  },
}));

// Secondary — white button with a gradient border
const Secondary = styled(Button)(() => ({
  color: '#000000',
  border: '1.5px solid transparent',
  borderRadius: '10px',
  backgroundImage:
    'linear-gradient(#FFFFFF, #FFFFFF), linear-gradient(135deg, #7852F8 0%, #84AEF6 100%)',
  backgroundOrigin: 'border-box',
  backgroundClip: 'padding-box, border-box',
  textTransform: 'none',
  // height: '54px',
  fontSize: { xs: '0.85rem', sm: '1rem' },
  fontWeight: 600,
  boxShadow: 'none',
  padding: '12px 18px 12px 16px',
  '&:hover': {
    backgroundImage:
      'linear-gradient(#F5F5F5, #F5F5F5), linear-gradient(135deg, #7852F8 0%, #84AEF6 100%)',
    boxShadow: 'none',
  },
}));

// Tertiary — solid #2563EB fill with a matching #2563EB border
const Tertiary = styled(Button)(() => ({
  backgroundColor: '#2563EB',
  color: '#FFFFFF',
  border: '1px solid #2563EB',
  borderRadius: '10px',
  textTransform: 'none',
  fontWeight: 600,
  boxShadow: 'none',
  padding: '12px 18px 12px 16px',
  '&:hover': {
    backgroundColor: '#1D4ED8',
    border: '1px solid #1D4ED8',
    boxShadow: 'none',
  },
}));

// Quaternary — outlined: white fill with a #2563EB border and #2563EB text
const Quaternary = styled(Button)(() => ({
  backgroundColor: '#FFFFFF',
  color: '#2563EB',
  border: '1px solid #2563EB',
  borderRadius: '10px',
  textTransform: 'none',
  fontWeight: 600,
  boxShadow: 'none',
  padding: '12px 18px 12px 16px',
  '&:hover': {
    backgroundColor: '#EFF4FF',
    border: '1px solid #2563EB',
    boxShadow: 'none',
  },
}));

export { Primary, Secondary, Tertiary, Quaternary };
